const getNextImageIndex = (currentIndex, totalImages) => {
  if (totalImages <= 0) return 0;
  return currentIndex < totalImages - 1 ? currentIndex + 1 : 0;
};

const getPreviousImageIndex = (currentIndex, totalImages) => {
  if (totalImages <= 0) return 0;
  return currentIndex > 0 ? currentIndex - 1 : totalImages - 1;
};

const getAdjacentInstanceId = ({ direction, instanceId, snapshot }) => {
  if (!snapshot || typeof instanceId !== "number") return null;

  const { pageIds = [] } = snapshot;
  const indexOnPage = pageIds.findIndex(id => id === instanceId);
  if (indexOnPage < 0) return null;

  if (direction === "previous") {
    return indexOnPage > 0 ? pageIds[indexOnPage - 1] : null;
  }
  return indexOnPage < pageIds.length - 1 ? pageIds[indexOnPage + 1] : null;
};

const getAdjacentInstanceOffset = ({ direction, instanceId, snapshot }) => {
  if (!snapshot || typeof instanceId !== "number") return null;

  const { count = 0, limit = 50, offset = 0, pageIds = [] } = snapshot;
  const indexOnPage = pageIds.findIndex(id => id === instanceId);
  if (indexOnPage < 0) return null;

  const globalIndex = offset + indexOnPage;

  if (direction === "previous") {
    const hasPrevious = globalIndex > 0;
    const previousId = indexOnPage > 0 ? pageIds[indexOnPage - 1] : null;
    return hasPrevious && !previousId ? Math.max(offset - limit, 0) : null;
  }

  const hasNext = globalIndex < count - 1;
  const nextId = indexOnPage < pageIds.length - 1 ? pageIds[indexOnPage + 1] : null;
  return hasNext && !nextId ? offset + limit : null;
};

const formatEditionLabel = ({ editionNumberFormatted }) =>
  editionNumberFormatted || null;

const formatArtistNames = (artists = []) =>
  artists.map(artist => artist.name).join(", ");

export {
  formatArtistNames,
  formatEditionLabel,
  getAdjacentInstanceId,
  getAdjacentInstanceOffset,
  getNextImageIndex,
  getPreviousImageIndex,
};
